import './miles/sky.jpg';
import './miles/sky-xs.jpg';
import './miles/screen-payments.png';
import './miles/screen-payments-xs.png';
import './miles/business-card-hand-x2.png';
import './miles/business-card-hand-x2-xs.png';

import './secure/keep.jpg';
import './secure/keep-xs.jpg';
import './secure/sign-up.jpg';
import './secure/sign-up-xs.jpg';

import './devise-singup.jpg';
import './devise-singup-xs.jpg';
import './devise-singin.jpg';
import './devise-singin-xs.jpg';

import './faq/screen-promo.jpg';
import './faq/screen-promo-xs.jpg';
import './faq/screen-add-cards.jpg';
import './faq/screen-add-cards-xs.jpg';
import './faq/screen-payment-view.jpg';
import './faq/screen-payment-view-xs.jpg';
import './faq/screen-payment-actions.jpg';
import './faq/screen-payment-actions-xs.jpg';
import './faq/screen-payment-edit.jpg';
import './faq/screen-payment-edit-xs.jpg';
import './faq/screen-payment-submit.jpg';
import './faq/screen-payment-submit-xs.jpg';

import './agents/phone-xs.jpg'
import './agents/phone.jpg'
import './agents/hammers-xs.png'
import './agents/hammers.png'
import './agents/mr-tan-deal-xs.jpg'
import './agents/mr-tan-deal.jpg'
import './agents/mr-tan-dedicated-xs.jpg'
import './agents/mr-tan-dedicated.jpg'
import './agents/mr-tan-happy-xs.jpg'
import './agents/mr-tan-happy.jpg'
import './agents/mr-tan-just-moved-xs.jpg'
import './agents/mr-tan-just-moved.jpg'
import './agents/provide-appliances.png';
import './agents/provide-appliances-xs.png';
import './agents/provide-cleaning.png';
import './agents/provide-cleaning-xs.png';
import './agents/provide-electrical.png';
import './agents/provide-electrical-xs.png';
import './agents/provide-outdoor.png';
import './agents/provide-outdoor-xs.png';
import './agents/provide-painting.png';
import './agents/provide-painting-xs.png';
import './agents/provide-plumbing.png';
import './agents/provide-plumbing-xs.png';
import './landlords/landlords-our-maintenance.png';
import './landlords/landlords-our-maintenance-xs.png';
import './landlords/landlords-best-quotes.png';
import './landlords/landlords-best-quotes-xs.png';
import './landlords/landlords-letter.png';
import './landlords/landlords-letter-xs.png';
import './landlords/landlords-writing-pad.png';
import './landlords/landlords-writing-pad-xs.png';



// WEBPACK FOOTER //
// app/javascript/frontend/images/index.js